import { render, staticRenderFns } from "./RoomNotifyItem.vue?vue&type=template&id=688c993f"
import script from "./RoomNotifyItem.vue?vue&type=script&lang=js"
export * from "./RoomNotifyItem.vue?vue&type=script&lang=js"
import style0 from "./RoomNotifyItem.vue?vue&type=style&index=0&id=688c993f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports